var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9375 2.7915L1.875 3.854L16 17.9998L17.0625 16.9373L2.9375 2.7915Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.05674 4.91377C3.78618 6.18103 3 7.9337 3 9.87C3 13.736 6.13401 16.87 10 16.87C11.9326 16.87 13.6822 16.0868 14.9489 14.8206L13.8891 13.7591C12.8938 14.7544 11.5188 15.37 10 15.37C6.96243 15.37 4.5 12.9076 4.5 9.87C4.5 8.34831 5.11796 6.97096 6.11662 5.97521L5.05674 4.91377ZM7.32781 5.06163L6.23531 3.96751C7.32238 3.27272 8.61416 2.87 10 2.87C13.866 2.87 17 6.004 17 9.87C17 11.2595 16.5951 12.5545 15.8969 13.6434L14.8044 12.5493C15.2475 11.7565 15.5 10.8427 15.5 9.87C15.5 6.83243 13.0376 4.37 10 4.37C9.03017 4.37 8.11896 4.62101 7.32781 5.06163Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.999f183cb1dc1b53d4bbc56cdcb16770.svg";
export { ForwardRef as ReactComponent };